import { Dispatch } from 'redux';
import { connect } from 'react-redux';
import { DispatchProps, OwnProps, StateProps } from './ExpenseListScreen';
import ExpenseList from './ExpenseListScreen';
import { StoreState } from 'src/store/reducers';
import { getExpenses } from '../../../../../../../../store/actions/expense-actions';
import { QueryParams } from '../../../../../../../../types/grid';

function mapStateToProps(state: StoreState): StateProps {
    return {
        data: state.expenses.data,
        inProgress: state.expenses.inProgress,
    };
}

function mapDispatchToProps(dispatch: Dispatch): DispatchProps {
    return {
        getData: (params: QueryParams) => dispatch(getExpenses(params)),
    };
}

const ExpenseListScreen = connect<StateProps, DispatchProps, OwnProps, StoreState>(
    mapStateToProps,
    mapDispatchToProps,
)(ExpenseList);

export default ExpenseListScreen;
